import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Stack, Skeleton } from '@mui/material'

import { unit, ICONS, COLORS } from '@hcr/ui'

export const DestinationLoading = () => (
  <Box
    bgcolor={COLORS.vaalea['60%']}
    display='flex'
    justifyContent='space-between'
    paddingTop={unit(3.5)}
    paddingX={unit(7)}
    paddingBottom={unit(4.5)}
  >
    <Stack gap={unit(0.5)}>
      <Skeleton width={unit(65)} height={unit(5.5)} variant='rectangular' />
      <Skeleton width={unit(35)} height={unit(4.5)} />
    </Stack>
    <FontAwesomeIcon fontSize={unit(5.5)} icon={ICONS.farChevronRight} />
  </Box>
)
